import React, { Component } from "react";
import DatePicker from "material-ui/DatePicker";
import RaisedButton from "material-ui/RaisedButton";
import Box from "../ui/Box";
import ReactEcharts from "components/ReactECharts";
import CHARTCONFIG from "constants/ChartConfig";
import Select from "react-select";
import Pagination from "react-js-pagination";
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
  TableFooter,
} from "material-ui/Table";

//services
import DataService from "../../services/DataService";
var ds = DataService;
import Helper from "../../services/Helper";
var help = Helper;
import LocalStorageService from "../../services/LocalStorageService";
var ls = LocalStorageService;

export default class LockStatsMain extends Component {
  constructor(props) {
    super(props);
    let start = new Date();
    start.setHours(0, 0, 0, 0);
    let x = new Date();
    x.setDate(x.getDate() + 7);
    x.setHours(23, 59, 59, 999);
    this.state = {
      all_rooms: [],
      activePage: 1,
      totalCount: 0,
      maxItems: 15,
      current_offset: 0,
      UDid: "",
      start: start,
      end: x,
      LOCKHISTORY: 51,
      locksData: [],
      lock_history: [],
      allLockHistory: [], 
      hotel_id: ls.getUserDetails().hotel_id,
      dialog: {
        open: false,
        head: "Dude",
        body: "This is working",
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />,
        ],
      },
    };
    this.getAllDevices();
  }

  closeDialog(refresh = 0) {
    this.setState({
      dialog: {
        head: "",
        body: "",
        open: false,
        actions: [],
      },
    });
    if (refresh) {
      this.refreshTable();
    }
  }

  refreshTable(e) {
    this.setState({ activePage: 1 }, () => {
      this.lockHistory();
    });
  }

  onChangePage(pageNumber) {
    this.setState({
      activePage: pageNumber,
    }, () => {
      this.updateDisplayedData();
    });
  }

  updateDisplayedData() {
    const { activePage, maxItems, allLockHistory } = this.state;
    const startIndex = (activePage - 1) * maxItems;
    const endIndex = startIndex + maxItems;
    const paginatedData = allLockHistory.slice(startIndex, endIndex);
    
    this.setState({
      lock_history: paginatedData,
    });
  }

  getAllDevices() {
    ds.getAllDevices(
      (data) => {
        if (data && data.status == 1) {
          for (let i of data.data) {
            i.label = i.hotel_room_no;
            i.value = i.UDid;
          }
          this.setState({
            locksData: data.data,
          });
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  lockHistory(e) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    ds.postLockHistory(
      {
        intent: this.state.LOCKHISTORY,
        hotel_id: this.state.hotel_id,
        UDid: this.state.UDid,
        startTime: this.state.start.getTime(),
        endTime: this.state.end.getTime(),
      },
      (data) => {
       
        this.setState({
          allLockHistory: data.data,
          activePage: 1,
          totalCount: data.data.length,
        }, () => {
          this.updateDisplayedData();
        });
        
      },
      (err) => {
        console.log("Error fetching keycards", err);
      }
    );
  }

  render() {
    const { activePage, maxItems, totalCount } = this.state;
    
    let pagination = null;
    if (totalCount > maxItems) {
      pagination = (
        <Pagination
          activePage={activePage}
          itemsCountPerPage={maxItems}
          totalItemsCount={totalCount}
          pageRangeDisplayed={5}
          onChange={this.onChangePage.bind(this)}
          itemClass="page-item"
          linkClass="page-link"
          activeClass="active"
          activeLinkClass="page-link"
        />
      );
    }

    return (
      <Box header="Lock History">
        <div>
          <form className="smart-form" onSubmit={this.lockHistory.bind(this)}>
            <fieldset style={{ paddingLeft: "2.4rem" }}>
              <div style={{ display: "flex", alignItems: "flex-end", gap: "20px", flexWrap: "wrap" }}>
                <div style={{ minWidth: "200px", flex: "1" }}>
                  <div className="false-placeholder" style={{ marginBottom: "8px" }}>
                    Select Room
                  </div>
                  <Select
                    id="room_numid"
                    ref={(ref) => {
                      this.select = ref;
                    }}
                    container="inline"
                    onBlurResetsInput={false}
                    onSelectResetsInput={false}
                    autoFocus
                    options={this.state.locksData}
                    simpleValue
                    clearable={true}
                    name="UDid"
                    disabled={false}
                    value={this.state.UDid}
                    onChange={(newValue) => {
                      this.setState({
                        UDid: newValue,
                      });
                    }}
                    searchable={true}
                    placeholder="Room Number"
                    style={{ width: "100%" }}
                  />
                </div>

                <div style={{ minWidth: "150px", flex: "1" }}>
                  <div className="false-placeholder" style={{ marginBottom: "8px" }}>
                    Start Date
                  </div>
                  <DatePicker
                    hintText="From"
                    container="inline"
                    name="ch_in_time"
                    value={this.state.start}
                    autoOk
                    style={{ width: "100%" }}
                    onChange={(e, value) => {
                      this.setState({
                        start: value,
                      });
                    }}
                  />
                </div>

                <div style={{ minWidth: "150px", flex: "1" }}>
                  <div className="false-placeholder" style={{ marginBottom: "8px" }}>
                    End Date
                  </div>
                  <DatePicker
                    hintText="To"
                    container="inline"
                    name="end"
                    value={this.state.end}
                    autoOk
                    style={{ width: "100%" }}
                    onChange={(e, value) => {
                      let end = new Date(value);
                      end.setHours(23, 59, 59, 999);
                      this.setState({
                        end: end,
                      });
                    }}
                  />
                </div>

                <div style={{ marginBottom: "8px" }}>
                  <RaisedButton
                    label="GO"
                    primary
                    type="submit"
                    style={{ minWidth: "80px" }}
                  />
                </div>
              </div>
            </fieldset>
          </form>
        </div>
        {this.state.lock_history && this.state.lock_history.length ? (
          <div className="box-body">
            <Dialog
              title={this.state.dialog.head}
              actions={this.state.dialog.actions}
              modal={false}
              open={this.state.dialog.open}
              onRequestClose={this.closeDialog.bind(this)}
              autoScrollBodyContent={true}
            >
              {this.state.dialog.body || "NA"}
            </Dialog>
            
            <div style={{ marginBottom: '10px', textAlign: 'right' }}>
              <small>
                Showing {((activePage - 1) * maxItems) + 1} to {Math.min(activePage * maxItems, totalCount)} of {totalCount} entries
              </small>
            </div>
            
            <Table
              height={"45vh"}
              fixedHeader={true}
              fixedFooter={true}
              selectable={false}
              multiSelectable={false}
              bodyStyle={{ minWidth: 680, overflowX: "auto" }}
            >
              <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                <TableRow>
                  <TableHeaderColumn tooltip="Time">
                    Time
                  </TableHeaderColumn>
                  <TableHeaderColumn tooltip="Status">
                    Status
                  </TableHeaderColumn>
                  <TableHeaderColumn tooltip="Username">
                    Username
                  </TableHeaderColumn>
                </TableRow>
              </TableHeader>

              <TableBody
                displayRowCheckbox={false}
                showRowHover={true}
                stripedRows={false}
              >
                {this.state.lock_history.map((row, index) => (
                  <TableRow key={row.recordId || index}>
                    <TableRowColumn style={{ overflow: "visible" }}>
                      {row.action_time}
                    </TableRowColumn>
                    <TableRowColumn style={{ overflow: "visible" }}>
                      {row.recordType}
                    </TableRowColumn>
                    <TableRowColumn style={{ overflow: "visible" }}>
                      {row.username}
                    </TableRowColumn>
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableRowColumn
                    colSpan="1"
                    style={{ textAlign: "left" }}
                  >
                    <small>Page {activePage} of {Math.ceil(totalCount / maxItems)}</small>
                  </TableRowColumn>
                  <TableRowColumn colSpan="1" style={{ textAlign: "right" }}>
                    {pagination}
                  </TableRowColumn>
                </TableRow>
              </TableFooter>
            </Table>
          </div>
        ) : (
          <div style={{ marginTop: "4rem" }}>
            <p className="text-center mt-1rem pb-1rem"> No Data Present! </p>
          </div>
        )}
      </Box>
    );
  }
}


// WEBPACK FOOTER //
// ./components/stats/LockStatsMain.js